import { __exports as d } from "../../../../_virtual/bodyTrap.js";
import "./portalOpenInstances.js";
import { __exports as i } from "../../../../_virtual/portalOpenInstances.js";
Object.defineProperty(d, "__esModule", {
  value: !0
});
d.resetState = f;
d.log = v;
var p = i, c = u(p);
function u(t) {
  return t && t.__esModule ? t : { default: t };
}
var e = void 0, o = void 0, r = [];
function f() {
  for (var t = [e, o], n = 0; n < t.length; n++) {
    var a = t[n];
    a && a.parentNode && a.parentNode.removeChild(a);
  }
  e = o = null, r = [];
}
function v() {
  console.log("bodyTrap ----------"), console.log(r.length);
  for (var t = [e, o], n = 0; n < t.length; n++) {
    var a = t[n], l = a || {};
    console.log(l.nodeName, l.className, l.id);
  }
  console.log("edn bodyTrap ----------");
}
function s() {
  if (r.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  r[r.length - 1].focusContent();
}
function m(t, n) {
  !e && !o && (e = document.createElement("div"), e.setAttribute("data-react-modal-body-trap", ""), e.style.position = "absolute", e.style.opacity = "0", e.setAttribute("tabindex", "0"), e.addEventListener("focus", s), o = e.cloneNode(), o.addEventListener("focus", s)), r = n, r.length > 0 ? (document.body.firstChild !== e && document.body.insertBefore(e, document.body.firstChild), document.body.lastChild !== o && document.body.appendChild(o)) : (e.parentElement && e.parentElement.removeChild(e), o.parentElement && o.parentElement.removeChild(o));
}
c.default.subscribe(m);
export {
  d as default
};
